import React, { useState, useEffect } from 'react';
import './Header.css';
import logo from "./icons/alvanium.png";
import { Link, useLocation } from 'react-router-dom';

function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
   
    const updateBodyPadding = () => {
      const width = window.innerWidth;
      if (width <= 480) {
        document.body.style.paddingTop = '60px';
      } else if (width <= 768) {
        document.body.style.paddingTop = '70px';
      } else {
        document.body.style.paddingTop = '80px';
      }
    };
   
    updateBodyPadding();
    window.addEventListener('resize', updateBodyPadding);
   
    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', updateBodyPadding);
      document.body.style.paddingTop = '0';
    };
  }, []);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 768 && mobileOpen) {
        setMobileOpen(false);
      }
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [mobileOpen]);

  const navItems = [
    { id: 'home', label: 'Home', path: '/' },
    
    { id: 'products', label: 'Products', path: '/products' },
    { id: 'solutions', label: 'Custom Solutions', path: '/customsolutions' },
    // { id: 'android', label: 'Android', path: '/android' },
    { id: 'about', label: 'About Alvanium', path: '/aboutalvanium' },
    { id: 'contact', label: 'Contact', path: '/contact' },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header className={`header glass-header ${scrolled ? 'scrolled' : ''}`}>
      <div className="header-inner">
        <div className="logo">
          <img src={logo} alt="Alvanium Logo" className="logo-image" />
          <span className="logo-text">Alvanium</span>
        </div>

        <nav className={`nav-links ${mobileOpen ? 'open' : ''}`}>
          {navItems.map((item) => (
            <Link
              key={item.id}
              to={item.path}
              className={`nav-link ${isActive(item.path) ? 'active' : ''}`}
              onClick={() => setMobileOpen(false)}
            >
              {item.label}
              <span className="nav-indicator"></span>
            </Link>
          ))}
        </nav>

        {/* <div className="header-right">
          <button className="nav-btn">
            <span>Get Started</span>
            <span className="arrow">→</span>
          </button>
        </div> */}

        <div className="mobile-toggle" onClick={() => setMobileOpen(!mobileOpen)}>
          <span className={`hamburger-line ${mobileOpen ? 'active' : ''}`}></span>
          <span className={`hamburger-line ${mobileOpen ? 'active' : ''}`}></span>
          <span className={`hamburger-line ${mobileOpen ? 'active' : ''}`}></span>
        </div>
      </div>
    </header>
  );
}

export default Header;